export const valorCustoTooltipText = `### Valor Custo é:
- Definido a partir do valor unitário do produto na importação da nota fiscal de entrada
- Utilizado para determinar o valor que será usado junto ao *markup* na definição do custo de venda quando não houver custo de referência
- Utilizado para definir o valor unitário no item da movimentação de estoque quando não há valor de custo do Produto do lote,
- Utilizado para definir o valor de custo dos itens da compra (Módulo Compras)
- Utilizado para definir o valor de uma embalagem no caso de uma venda do tipo Transferência
- Utilizado na exibição do detalhe da manipulação, multiplicando pela quantidade de pesagem
`;

export const custoReferenciaTooltipText = `### Custo de Referência é utilizado:
- No cálculo do valor da venda, multiplicando com o markup, respeitando o tipo de markup
- No relatório de Cobertura de Estoque, na coluna de Custo Médio, quando o mesmo não está presente
`;
